<div class="organization-credits-page">
    <div class="loading-spinner-container" *ngIf="isLoading">
        <div class="tryb-design-spinner"></div>
    </div>

    <p class="error-message" *ngIf="hasError">
        {{ 'default.errorMessage' | translate }}
    </p>

    <section class="budget-card" *ngIf="budget && !isLoading && !hasError">
        <p class="period">
            {{ budget.periodStartDate | localizedDate: 'shortDate' }} -
            {{ budget.periodEndDate | localizedDate: 'shortDate' }}
            ({{
                'organization.organizationArea.credits.currentBillingPeriod'
                    | translate
            }})
        </p>

        <div class="budget-summary">
            <div class="budget-figure">
                <span class="amount">
                    {{
                        budget.isUnlimited
                            ? '∞'
                            : (budget.total | number: '1.0-0' : currentLanguage)
                    }}
                </span>
                <span class="credits-label">
                    {{
                        'organization.organizationArea.credits.credits'
                            | translate
                    }}
                </span>
                <span class="description">
                    {{
                        'organization.organizationArea.credits.totalAvailable'
                            | translate
                    }}
                </span>
            </div>

            <div class="vertical-divider"></div>

            <div class="budget-figure">
                <span class="amount">
                    {{ budget.used | number: '1.0-0' : currentLanguage }}
                </span>
                <span class="credits-label">
                    {{
                        'organization.organizationArea.credits.credits'
                            | translate
                    }}
                </span>
                <span class="description">
                    {{
                        'organization.organizationArea.credits.used' | translate
                    }}
                </span>
            </div>

            <div class="vertical-divider"></div>

            <div class="budget-figure available-figure">
                <span class="amount">
                    {{
                        budget.isUnlimited
                            ? '∞'
                            : (budget.available
                              | number: '1.0-0' : currentLanguage)
                    }}
                </span>
                <span class="credits-label">
                    {{
                        'organization.organizationArea.credits.credits'
                            | translate
                    }}
                </span>
                <span class="description">
                    {{
                        'organization.organizationArea.credits.stillAvailable'
                            | translate
                    }}
                </span>
            </div>

            <span class="percentage-badge" *ngIf="showPercentage">
                {{
                    'organization.organizationArea.credits.budgetUsed'
                        | translate: { percentage: budget.usedPercentage }
                }}
            </span>
        </div>

        <div class="budget-bar" aria-label="Organization credit budget">
            <div
                class="used-segment"
                [style.width.%]="usedWidth"
                data-testid="used-segment"
            ></div>
            <div
                *ngIf="showAvailableSegment"
                class="available-segment"
                [style.width.%]="availableWidth"
                data-testid="available-segment"
            ></div>
        </div>
    </section>
</div>
